import { render, staticRenderFns } from "./marketDnsSetting.vue?vue&type=template&id=4f874c9b&scoped=true&"
import script from "./marketDnsSetting.vue?vue&type=script&lang=js&"
export * from "./marketDnsSetting.vue?vue&type=script&lang=js&"
import style0 from "./marketDnsSetting.vue?vue&type=style&index=0&id=4f874c9b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f874c9b",
  null
  
)

export default component.exports